/**
 * Selects whether the meetings filter modal is currently open
 * @param {Object} state - Redux state
 * @returns {boolean}
 */
export const isFilterModalOpenSelector = (state) => state.meetingsFilterModal?.isOpen || false
